<template>
  <div class="main-collected">
    <AdvancedCalc v-if="haveAdvancedCalcs == true" :next="next" />
    <div v-else>
      <div class="container-collected">
        <div>
          <label>{{ $t('criar-tags') }}</label>
          <b-tabs class="tab-create-tags" card>
            <b-tab :title="$t('coletor')" class="set-variable" @click="updateTab(0)" active>
              <label for="ind-calcType">{{ $t('nome-do-coletor') }}</label>
              <b-form-input :id="'tag-name'" size="sm" v-model="nameTag" :placeholder="$t('ex-moagemmes')"
                @keyup="updateCollectorName">
              </b-form-input>

              <label for="ind-calcType" class="mt-1">{{ $t('selecione-a-base-de-coleta') }}</label>
              <b-form-select id="ind-calcType" size="sm" v-model="syntaxeSelected" :options="syntaxesToSelect">
              </b-form-select>

              <div class="new-tag">
                <span v-for="variable, index in variables" :key="index">
                  <label class="mt-2" :for="variable.key">{{ variable.name }}</label>
                  <b-form-input size="sm" :id="`Tag-${index}`" v-model="variable.tag" placeholder="Ex: Tag1">
                  </b-form-input>
                </span>

                <!-- INTELUP -->
                <div v-if="canShowIntelupSpace" class="mt-1">
                  <b-form-input :id="`tag-name`" size="sm" placeholder="Unidade de produção"
                    v-model="intelupProductionUnit">
                  </b-form-input>
                </div>
                <!--/ INTELUP -->

                <!-- PI SYSTEM -->
                <div v-if="canShowPISystemSpace" class="mt-1">
                  <b-form-checkbox v-model="piSytemFilter" name="check-button" switch size="sm">
                    Ignorar valor zero ao coletar.
                  </b-form-checkbox>
                </div>
                <!--/ PI SYSTEM -->

                <!-- PENTAGRO COLLECTOR -->
                <div v-if="canShowPentagroServer && databasesPentagroCollector.length > 2">
                  <label for="server-collector" class="mt-1">{{ $t('selecione-o-servidor-do-coletor-pentagro') }}</label>
                  <b-form-select id="server-collector" size="sm" v-model="databasesOpcSelected"
                    :options="databasesPentagroCollector">
                  </b-form-select>
                </div>
                <!--/PENTAGRO COLLECTOR -->

                <!-- OPC COLLECTOR -->
                <div v-if="canShowOpcSpace && opcServerList.length > 2">
                  <label for="server-opc" class="mt-1">{{ $t('selecione-o-servidor-opc-do-tag') }}</label>
                  <b-form-select id="server-opc" size="sm" v-model="opcServerSelected" :options="opcServerList">
                  </b-form-select>
                </div>
                <div v-if="canShowPentagroServer && !externalDatabaseIsOk" class="atention-area">
                  <b-icon class="atention-icon" :title="$t('nao-ha-posicao-configurada-para-este-indicador')"
                    icon="exclamation-triangle" @click="call('step-4')">
                  </b-icon>
                  <p>{{ $t('atencao-algumas-bases-externas-nao-estao-acessiveis') }}</p>
                </div>
                <!--/ OPC COLLECTOR -->

              </div>
            </b-tab>

            <b-tab id="select-const" :title="$t('constante')" class="set-variable" @click="updateTab(1)">
              <label for="ind-Name">{{ $t('nome-da-constante') }}</label> <input v-if="nameConstant == 'selftest'"
                id="testing-drop" @change="testingDragingDrop" v-model="testingDraging" type="text">
              <b-form-input id="tag-const" v-model="nameConstant" :placeholder="$t('ex-fatorcorrecao')" maxlength="50"
                @keyup="updateCosntant">
              </b-form-input>
              <label for="ind-calcType">{{ $t('valor-da-constante') }}</label>
              <b-form-input :id="`number-const`" type="number" max="9999999999999999999" v-model="valueConstante"
                placeholder="Ex: 15555.454">
              </b-form-input>
            </b-tab>
            <b-tab id="select-indicator" :title="$t('indicador-0')" class="set-variable" @click="updateTab(2)">
              <label for="ind-Name">{{ $t('procure-um-indicador') }}</label>
              <b-form-select id="tag-indicator" v-model="indicatorSelected" size="sm" :options="indicators"
                @change="updateNameIndicator">
              </b-form-select>
              <label class="mt-2">Tag: <strong>{{ this.indicatorValue }}</strong></label>
            </b-tab>
          </b-tabs>
          <div class="collector-buttons">
            <b-icon id="clean-form" class="icon-button-pentagro mr-2 mt-1" :title="$t('limpar-formulario-0')"
              icon="eraser" @click="cleanForm"></b-icon>
            <b-icon id="add-tag" class="icon-button-pentagro mr-2 mt-1" :title="$t('adicionar-tag')" icon="plus-circle"
              @click="addTag"></b-icon>
          </div>
        </div>

        <div class="calculate-collected">
          <label>{{ $t('coletores-criados') }}</label>
          <b-overlay id="overlay-background" class="form-manage" :show="loadingOpcTags" rounded="sm">
            <div v-if="!reloading" class="tags-list">
              <label :id="'tag_' + tag.name" v-for="tag, index in tagsCreated" :title="$t('clique-para-visualizar')"
                class="tag-item" :key="index" @click="updateForm(tag)" draggable="true" @dragstart="drag">
                {{ tag.name }} <span v-if="!tag.used" class="remove-tag" :title="$t('remover') + ' ' + tag.name"
                  @click="askRemoveTag(tag)">X</span>
              </label>
            </div>
            <div v-else class="tags-list"></div>
          </b-overlay>
          <div>
            <label class="mt-2" for="">{{ $t('operadores-aritimeticos') }}</label>
            <div class="arithmetic-operators">
              <label v-for="tag, index in tagsOperations" :key="index" :id="`operation-${index}`"
                :title="$t('arraste-para-efetuar-o-calculo')" draggable="true" @dragstart="drag">
                {{ tag }}
              </label>
            </div>
          </div>
          <label class="mt-2">{{ $t('area-de-aplicacao') }} <strong class="ml-1">{{ typeCalculate }}</strong></label>
          <div class="space-calcaulation">
            <b-tabs pills card vertical end class="tab-calculations">
              <b-tab :disabled="disableOnline || viwsAgregations.get('ON')" vi :title="$t('online')"
                @click="setTypeCalculte(0)" active>
                <div id="calculation-area-online" class="calculation-area" @dragover="allowDrop" @drop="drop"></div>
              </b-tab>
              <b-tab :disabled="viwsAgregations.get('LD')" :title="$t('dia')" @click="setTypeCalculte(1)">
                <div id="calculation-area-day" class="calculation-area" @dragover="allowDrop" @drop="drop"></div>
              </b-tab>
              <b-tab :disabled="viwsAgregations.get('CW')" :title="$t('semana')" @click="setTypeCalculte(2)">
                <div id="calculation-area-week" class="calculation-area" @dragover="allowDrop" @drop="drop"></div>
              </b-tab>
              <b-tab :disabled="viwsAgregations.get('CM')" :title="$t('mes-0')" @click="setTypeCalculte(3)">
                <div id="calculation-area-month" class="calculation-area" @dragover="allowDrop" @drop="drop"></div>
              </b-tab>
              <b-tab :disabled="viwsAgregations.get('CY')" :title="$t('safra-0')" @click="setTypeCalculte(4)">
                <div id="calculation-area-harvest" class="calculation-area" @dragover="allowDrop" @drop="drop"></div>
              </b-tab>
            </b-tabs>
          </div>
          <div class="collector-buttons">
            <div>
              <b-icon id="clear-calc" class="icon-button-pentagro mr-2 mt-1" :title="$t('limpar-calculo')" icon="eraser"
                @click="cleanCalculate"></b-icon>
              <b-icon id="back-space" class="icon-button-pentagro mr-2 mt-1" :title="$t('apagar-ultimo')"
                icon="arrow-return-left" @click="backspaceCalculate"></b-icon>
            </div>
            <b-icon id="next-step" class="icon-button-pentagro mr-2 mt-1" :title="$t('proximo')" icon="arrow-right"
              @click="next"></b-icon>
          </div>
        </div>
      </div>
      <b-modal id="confirmRemoveTag" ok-variant=danger :title="$t('atencao')" :ok-title="$t('yes')"
        :cancel-title="$t('no')" @ok="removeTag">{{ $t('confirma-remover-o-tag') + [transientValue.name] + "?" }}
      </b-modal>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { defaultSuccess, showError, urlMainAPI } from '../../../../../global';
import IndicatorDataSource from "../../utilities/IndicatorDataSource"
import AdvancedCalc from '../../utilities/AdvancedCalc.vue';
import Mediator from '../../utilities/Mediator'
import MediatorCollector from './MediatorCollector'
import { mapState } from 'vuex';
import Indicator from '../../utilities/Indicator';

export default {
  name: "Manage-Collected-Reference",
  components: { AdvancedCalc },
  data() {
    return {
      step: "step-2",
      nextStep: "step-3",
      syntaxes: new Map,
      syntaxesToSelect: [],
      syntaxeSelected: null,
      variables: [],
      tagsCreated: [],
      tagsOperations: ["(", ")", "+", "-", "*", "/"],
      tabSelected: 0,
      nameTag: "",
      nameConstant: "",
      valueConstante: 0,
      transientValue: {},
      disableOnline: false,
      indicators: [],
      indicatorSelected: null,
      indicatorValue: "",
      indexCalcType: 0,
      typeCalculate: "Online",
      typesCalculate: ["Online", "Dia", "Semana", "Mês", "Safra"],
      showError: showError,
      testingDraging: "",
      reloading: false,
      loadingOpcTags: false,

      canShowPentagroServer: false,
      databasesPentagroCollector: [],

      canShowIntelupSpace: false,
      intelupProductionUnit: "",

      canShowPISystemSpace: false,
      piSytemFilter: false,

      canShowOpcSpace: false,
      dataDatabase: {},
      databasesOpcSelected: null,
      opcServerList: [],
      opcServerSelected: null,
      opcServerUniqui: false,

      viwsAgregations: new Map(),
      externalDatabaseIsOk: false,
      haveAdvancedCalcs: false,
      hasPentagroCollector: false,
    }
  },

  computed: mapState(["user"]),

  watch: {
    syntaxeSelected(key) {
      this.variables = [];
      if (!Mediator.data.formByOpcSyntaxes || !key) return

      this.indicatorSelected = null
      this.opcServerSelected = this.opcServerUniqui ? this.opcServerSelected : null

      this.piSytemFilter = false;
      this.canShowOpcSpace = false
      this.canShowPentagroServer = false;
      this.canShowPISystemSpace = false
      this.canShowIntelupSpace = false

      key = key.split(":")[0]
      this.updateScreeToPentagroServer(key)
      Mediator.data.formByOpcSyntaxes[key].forEach(tag => {
        this.variables.push({
          name: tag,
          tag: "",
        })
      })
    },

    tagsCreated() {
      MediatorCollector.notify(null, "load-calc")
    },

    databasesOpcSelected(value) {
      if (!this.dataDatabase.opcServerList || !this.dataDatabase.opcServerList[value]) return
      this.opcServerList = [{ value: null, text: this.$t('selecione-um-servidor-opc'), disabled: true }]
      this.opcServerList = [...this.opcServerList, ...this.dataDatabase.opcServerList[value].map(t => ({ value: t, text: t }))]
    }
  },

  methods: {
    getNotePentagroServer() {
      if (this.canShowOpcSpace)
        return `${this.databasesOpcSelected}|AUTO|${this.opcServerSelected}`
      if (this.canShowIntelupSpace)
        return `${this.databasesOpcSelected}|INTEL|${this.intelupProductionUnit}`
      if (this.canShowPISystemSpace)
        return `${this.databasesOpcSelected}|PISYS|${this.piSytemFilter}`
    },

    updateScreeToPentagroServer(key) {
      if (key.toUpperCase().includes("AUTO"))
        this.canShowOpcSpace = true

      if (key.toUpperCase().includes("INTEL"))
        this.canShowIntelupSpace = true

      if (key.toUpperCase().includes("PISYS"))
        this.canShowPISystemSpace = true

      if (this.canShowOpcSpace)
        this.canShowPentagroServer = true;
    },

    testingDragingDrop() {
      let value = this.testingDraging;
      if (!this.testingDraging) return
      this.drop({
        preventDefault() { },
        dataTransfer: {
          getData() {
            return value
          }
        }
      })
    },

    allowDrop(ev) {
      ev.preventDefault();
    },

    drag(ev) {
      ev.dataTransfer.setData("tag", ev.target.id);
    },

    drop(ev) {
      ev.preventDefault();
      var key = ev.dataTransfer.getData("tag").replace("tag_", "");
      if (!key) return
      MediatorCollector.notify(key, "insert-element")
    },

    updateCollectorName() {
      this.nameTag = this.adjustTag(this.nameTag)
    },

    updateCosntant() {
      this.nameConstant = this.adjustTag(this.nameConstant)
    },

    updateNameIndicator() {
      let name = this.indicators.find(i => i.value == this.indicatorSelected)
      if (name)
        this.indicatorValue = this.adjustTag(name.text).replace(/\//g, "-")
          .replace(/[^a-z0-9-]/gi, "")
          .replace(/(^[0-9])/, "_$1");
    },

    adjustTag(value) {
      return value.replace(/\//g, "-")
        .replace(/[^a-z0-9_]/gi, "")
        .replace(/(^[0-9])/, "_$1")
        .substring(0, 45);
    },

    cleanCalculate() {
      MediatorCollector.notify(null, "clean-collector")
    },

    backspaceCalculate() {
      MediatorCollector.notify(null, "backspace-collector")
    },

    addTag() {
      try {
        this.validForm()
      }
      catch (e) {
        showError(e)
        return
      }

      let tag = {}
      if (this.tabSelected == 0) {
        tag = new IndicatorDataSource({
          key: `${this.syntaxeSelected}:${this.nameTag}`,
          name: this.adjustTag(this.nameTag),
          variables: this.variables,
          type: this.tabSelected,
          used: false,
          note: this.getNotePentagroServer()
        })
      }
      else if (this.tabSelected == 1) {
        tag = new IndicatorDataSource({
          key: this.adjustTag(this.nameConstant),
          name: this.adjustTag(this.nameConstant),
          variables: [this.valueConstante],
          type: this.tabSelected,
          used: false
        })
      }
      else if (this.tabSelected == 2) {
        tag = new IndicatorDataSource({
          key: this.indicatorSelected,
          name: this.indicatorValue,
          variables: [this.indicatorSelected],
          type: this.tabSelected,
          used: false
        })
      }

      this.tagsCreated.push(tag)
      Mediator.notify(this, "update-step-2")
      this.cleanForm()
    },

    askRemoveTag(tag) {
      this.transientValue = tag
      this.$bvModal.show("confirmRemoveTag");
    },

    removeTag() {
      let index = -1;
      this.tagsCreated.forEach((tag, i) => {
        if (tag.name == this.transientValue.name)
          index = i
      })
      if (index > -1)
        this.tagsCreated.splice(index, 1)
    },

    validForm() {
      if (!this.nameTag && this.tabSelected == 0)
        throw this.$t('o-campo-nome-do-tag-nao-pode-ser-em-branco')

      if (this.tabSelected == 0 && this.canShowPentagroServer && !this.databasesOpcSelected && this.hasPentagroCollector)
        throw this.$t('o-campo-coletor-pentagro-nao-pode-ser-em-branco')

      if (this.tabSelected == 0 && this.canShowPentagroServer && !this.databasesOpcSelected)
        throw this.$t("pentagro-collector-nao-encontrado")

      if (this.tabSelected == 0 && this.canShowIntelupSpace && !this.intelupProductionUnit)
        throw this.$t('o-campo-unidade-de-produção-do-tag-intelup-nao-pode-ser-em-branco')

      if (this.tabSelected == 0 && this.canShowOpcSpace && !this.opcServerSelected && this.hasPentagroCollector)
        throw this.$t('o-campo-servidor-opc-do-tag-nao-pode-ser-em-branco')

      if (!this.nameConstant && this.tabSelected == 1)
        throw this.$t('o-campo-nome-da-constante-nao-pode-ser-em-branco')

      let tagFound = this.tagsCreated.find(t => t.name == this.nameTag || t.name == this.nameConstant)
      if (tagFound)
        throw this.$t('variavel-tagfound-name-ja-foi-alocada-entre-com-um-nome-de-variavel-diferente', [tagFound.name])
    },

    cleanForm() {
      this.nameTag = "";
      this.nameConstant = "";
      this.valueConstante = 0;
      this.syntaxeSelected = null
      this.indicatorSelected = null
      this.indicatorValue = ""
      this.canShowPentagroServer = false;
      this.canShowOpcSpace = false
      this.canShowPISystemSpace = false
      this.canShowIntelupSpace = false
      this.opcServerSelected = !this.opcServerUniqui ? null : this.opcServerSelected
      this.databasesOpcSelected = this.databasesPentagroCollector.length > 2 ? null : this.databasesOpcSelected
      this.intelupProductionUnit = ""
      this.piSytemFilter = false
    },
    updateTab(index) {
      this.cleanForm();
      this.tabSelected = index
    },

    updateForm(tag) {
      this.cleanForm();
      MediatorCollector.notify(tag, "update-form")
    },

    setTypeCalculte(typeCalculate) {
      this.indexCalcType = typeCalculate;
      this.typeCalculate = this.typesCalculate[typeCalculate]
    },

    loadSintaxes() {
      if (!Mediator.data.collectionSintaxes) {
        setTimeout(() => {
          this.loadSintaxes()
        }, 200);
        return
      }

      this.syntaxesToSelect = Mediator.data.collectionSintaxes.map(s => {
        let key = `${s.origin}-${s.agregation}`
        if (!this.syntaxes.has(key))
          this.syntaxes.set(key, s);

        return { value: key, text: key }
      })
      this.syntaxesToSelect.sort((a, b) => a.text > b.text ? 1 : a.text < b.text ? -1 : 0)
      this.syntaxesToSelect.splice(0, 0, { value: null, text: this.$t('selecione-uma-base-de-coleta') })

      this.indicators = Mediator.data.indicators.map(i => ({ value: `${i.id}-${i.productionUnitId}-${i.system}`, text: i.indicatorName }));
      this.indicators.sort((a, b) => a.text > b.text ? 1 : a.text < b.text ? -1 : 0)
      this.indicators.splice(0, 0, { value: null, text: this.$t('selecione-um-indicador') })
    },

    next() {
      Mediator.notify(this.ind, "update-indicator")
      Mediator.notify(this, "select-step-by-form")
    },

    loadTagsCreated(indicator) {
      let collectorsFound = indicator.indRealList.filter(ind => ind.name && ind.name != "NOTFOUND" && ind.name != "");
      
      let emptyIndicator = new Indicator();
      if(collectorsFound.length == 0 && !Mediator.mainScreen.isNew){
        
        this.tagsCreated = emptyIndicator.indRealList;
        MediatorCollector.tagsCreated = emptyIndicator.indRealList;
        MediatorCollector.valueOnline = emptyIndicator.valueOnline;
        MediatorCollector.valueDay = emptyIndicator.valueDay;
        MediatorCollector.valueWeek = emptyIndicator.valueWeek;
        MediatorCollector.valueMonth = emptyIndicator.valueMonth;
        MediatorCollector.valueHarvest = emptyIndicator.valueHarvest;

        showError(this.$t("syntaxe-nao-econtrada"))
        return;
      }

      this.tagsCreated = collectorsFound;
      MediatorCollector.tagsCreated = collectorsFound;
      MediatorCollector.valueOnline = indicator.valueOnline != "NOTFOUND" ? indicator.valueOnline : emptyIndicator.valueOnline;
      MediatorCollector.valueDay = indicator.valueDay != "NOTFOUND" ? indicator.valueDay : emptyIndicator.valueDay;
      MediatorCollector.valueWeek = indicator.valueWeek != "NOTFOUND" ? indicator.valueWeek : emptyIndicator.valueWeek;
      MediatorCollector.valueMonth = indicator.valueMonth != "NOTFOUND" ? indicator.valueMonth : emptyIndicator.valueMonth;
      MediatorCollector.valueHarvest = indicator.valueHarvest != "NOTFOUND" ? indicator.valueHarvest : emptyIndicator.valueHarvest;
    
      if (indicator.calcType == "diario" || indicator.calcType == "sazonal") {
        this.disableOnline = true
        this.indexCalcType = 1
        this.typeCalculate = this.typesCalculate[1]
      } else {
        this.disableOnline = false
        this.indexCalcType = 0
        this.typeCalculate = this.typesCalculate[0]
      }
    },

    update() {
      Mediator.notify(this, "update-step-2")
    },

    async getOpstionsOpcDatabase() {
      this.loadingOpcTags = true;
      defaultSuccess(this.$t("consultando-servidores-externos"))
      await axios.get(`${urlMainAPI}/getdatafrompgdicollector`).then(res => {
        if (res.status == 200) {
          this.dataDatabase = res.data
          let opcServerList = Object.keys(this.dataDatabase.opcServerList)
          let databases = Object.keys(this.dataDatabase.databasesOpcList)
          this.databasesPentagroCollector = []

          this.externalDatabaseIsOk = true;
          defaultSuccess(this.$t("servidores-localizados"))

          if(opcServerList.length == 1){
            this.opcServerSelected = this.dataDatabase.opcServerList[opcServerList[0]]
            this.opcServerUniqui = true
          }

          if (databases.length == 1) {
            this.databasesOpcSelected = databases[0]
            return;
          }

          if (databases.length > 0) {
            this.hasPentagroCollector = true;
          }
          this.databasesPentagroCollector = [{ value: null, text: this.$t('selecione-o-coletor-pentagro'), disabled: true }]
          databases.forEach(key => {
            this.databasesPentagroCollector.push({ value: key, text: this.dataDatabase.databasesOpcList[key] })
          })
        }
      }).catch(error => {
        this.externalDatabaseIsOk = false;
        showError(this.$t("falha-connectar-servidores-externos"))
        console.error(error)
      });
      this.loadingOpcTags = false;
    },

    setViewsAgregations() {
      if (this.user.Permissions.dashboard01) {
        this.viwsAgregations.set(this.user.Permissions.dashboard01.parameter, !this.user.Permissions.dashboard01.permission)
      }
      if (this.user.Permissions.dashboard02) {
        this.viwsAgregations.set(this.user.Permissions.dashboard02.parameter, !this.user.Permissions.dashboard02.permission)
      }
      if (this.user.Permissions.dashboard03) {
        this.viwsAgregations.set(this.user.Permissions.dashboard03.parameter, !this.user.Permissions.dashboard03.permission)
      }
      if (this.user.Permissions.dashboard04) {
        this.viwsAgregations.set(this.user.Permissions.dashboard04.parameter, !this.user.Permissions.dashboard04.permission)
      }
      if (this.user.Permissions.dashboard05) {
        this.viwsAgregations.set(this.user.Permissions.dashboard05.parameter, !this.user.Permissions.dashboard05.permission)
      }
    },
  },

  mounted() {
    this.haveAdvancedCalcs = Mediator.checkAdvancedCalcs(Mediator.indicator, "value")
    this.loadSintaxes()
    this.getOpstionsOpcDatabase()
    Mediator.notify(this, "init-step")
    MediatorCollector.notify(this, "init-step")
    this.setViewsAgregations()
  }
}
</script>

<style scoped>
h5 {
  text-align: center;
}

.main-collected {
  display: flex;
  justify-self: center;
  flex-direction: column;
  justify-items: center;
  width: 100%;
}

.container-collected {
  display: grid;
  grid-template-columns: 40% 60%;
  gap: 8px;
  min-height: 50vh;
}

.calculate-collected {
  border-left: 1px solid #0003;
  padding-left: 8px;
  max-height: inherit !important;
  ;
  overflow-y: auto;
}


.set-variable {
  min-height: 53vh;
}

.tags-list {
  background-color: #fafafa;
  box-shadow: 0 0 3px #0001;
  border-radius: 4px;
  min-height: 20vh;
  padding: 2px;
  max-height: inherit !important;
  ;
  overflow-y: auto;

}

.tag-calc,
.operation-tag,
.arithmetic-operators>label,
.tag-item {
  background-color: #00000010;
  font-weight: 400;
  padding: 2px 6px;
  border-radius: 4px;
  margin: 2px;
  cursor: pointer;
  border: 1px solid #0001;
  color: #555;
}

.arithmetic-operators>label:hover,
.tag-item:hover {
  background-color: #00a39f4d;
}

.arithmetic-operators>label:hover {
  background-color: #ff5b0030;
}

.arithmetic-operators>label {
  min-width: 24px;
  text-align: center;
}

.tab-calculations {
  min-height: 17vh;
  flex-wrap: nowrap;
}

.remove-tag {
  color: #000;
  font-weight: 500;
}

.remove-tag:hover {
  color: #f00;
  font-weight: 500;
}

.collector-buttons {
  display: flex;
  justify-content: space-between;
}

.space-calcaulation {
  min-height: 23.7vh;
}

.button-pentagro {
  background-color: #00A39F;
  border-color: #00A39F;
}

@media (min-height: 770px) {

  .container-collected,
  .set-variable {
    min-height: 63vh;
  }
}
</style>

<style>
/* INICIO - AREA DE CALCULOS */

.tab-calculations ul {
  padding: 0;
  background-color: #00000001;
}

.tab-calculations li {
  width: 72px;
  padding: 0;
}

.container-collected>div>div>div>ul.card-header {
  padding: 12px 16px;
}

.container-collected a,
.tab-calculations a {
  padding: 3.7px 4px;
  color: #0008 !important;
  background-color: #00000010 !important;
  font-weight: 500;
  border-bottom-left-radius: 0px;
  border-top-left-radius: 0px;
}

.container-collected .card-header {
  background-color: #fafafa !important;
}

.container-collected a.active,
.tab-calculations a.active {
  background-color: #fafafa !important;
  color: #ff5f00 !important;
  text-decoration: underline !important;
  ;
}

.tab-calculations a.nav-link {
  border-bottom-left-radius: 0px;
  border-top-left-radius: 0px;
  height: 4.4vh;
}

.container-collected a.nav-link:hover,
.tab-calculations a.nav-link:hover {
  background-color: #fafafa !important;
}

.tab-create-tags a.active {
  background-color: #fff !important;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.tab-calculations>div>div {
  padding: 0;
}

.tab-calculations>div>div>div {
  min-height: 22vh;
  max-width: 639px;
  overflow-x: auto
}

.calculation-area {
  background-color: #fafafa;
  border-radius: 4px;
  border-bottom-right-radius: 0px;
  border-top-right-radius: 0px;
  height: 100%;
}

/* FIM - AREA DE CALCULOS */

.atention-area {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
}

.atention-icon {
  color: #ff5f00;
  margin: 0 8px;
  font-size: 20px;
}

.atention-icon:hover {
  color: #ff5f0090;
}

.atention-area>p {
  font-size: 0.6rem;
  margin-bottom: 0;
  font-weight: 700;
  cursor: default;
}

@media (min-height: 770px) {
  .tab-calculations>div>div>div {
    min-height: 32.5vh !important;
    max-width: 823px;
    overflow-x: auto
  }

  .tab-calculations a.nav-link {
    height: 6.5vh;
    padding: 15px 0 0 9px;
  }

  .tags-list {
    min-height: 23vh !important;
  }

  .space-calcaulation {
    min-height: 35.8vh;
  }
}
</style>